import { injectDataIntoContent } from "directus-extension-flexible-editor/content";

export const useConferences = () => {

    const { getItems } = useDirectusItems();

    const getConferencesPage = async () => {
        const fetchPage = getItems<any>({
            collection: 'conferences',
            params: {
                limit: -1,
                fields: [
                    'cover.id',
                    'cover.width',
                    'cover.height',
                    'cover.title',
                    'cover.blurhash',

                    'title',
                    'summary',
                    'topic',
                    'url',
                    'date_start',
                    'date_end',
                    'location',
                ],
                filter: { status: { _eq: 'published' } },
                sort: '-date_start'
            }
        })

        const [conferences] = await Promise.all([fetchPage])
        return { conferences }
    }

    const getConference = async (slug: any) => {
        const fetchPage = getItems<any>({
            collection: 'conferences',
            params: {
                fields: [
                    'cover.id',

                    'title',
                    'summary',
                    'topic',
                    'date_start',
                    'date_end',
                    'location',
                    'season',

                    'show_registration_page',
                    'show_gallery_page',
                    'show_programme_page',
                    'show_workshop_page',
                    'show_speakers_page',
                    'show_accomodation_page',
                    'show_links_page'
                ],
                filter: { url: { _eq: slug } },
            }
        })

        const [conferences] = await Promise.all([fetchPage])

        return {
            page: conferences ? conferences[0] : null
        }
    }

    const getConferenceOverview = async (slug: any) => {
        const fetchPage = getItems<any>({
            collection: 'conferences',
            params: {
                fields: [
                    'title',

                    'body',
                    'body_nodes.id',
                    'body_nodes.item:articles_nodes_image.image.id',
                    'body_nodes.item:articles_nodes_image.image.width',
                    'body_nodes.item:articles_nodes_image.image.height',
                    'body_nodes.item:articles_nodes_image.image.title',
                    'body_nodes.item:articles_nodes_image.image.description',
                    'body_nodes.item:articles_nodes_image.image.light_caption',
                    'body_nodes.item:articles_nodes_image.image.blurhash',
                    'body_nodes.item:articles_nodes_image.caption',
                    'body_nodes.item:articles_nodes_youtube.youtube_link',

                    'hosts.conferences_hosts_id.avatar.id',
                    'hosts.conferences_hosts_id.avatar.width',
                    'hosts.conferences_hosts_id.avatar.height',
                    'hosts.conferences_hosts_id.avatar.title',
                    'hosts.conferences_hosts_id.avatar.blurhash',
                    'hosts.conferences_hosts_id.name',
                    'hosts.conferences_hosts_id.role'
                ],
                filter: { url: { _eq: slug } },
            }
        })

        const [conferences] = await Promise.all([fetchPage])

        if (conferences && conferences[0]) {
            injectDataIntoContent(conferences[0].body_nodes, conferences[0].body)
            delete conferences[0].body_nodes
        }

        return {
            page: conferences ? conferences[0] : null
        }
    }

    const getConferenceGallery = async (slug: any) => {
        const fetchPage = getItems<any>({
            collection: 'conferences',
            params: {
                fields: [
                    'id',
                    'title',
                    'gallery.directus_files_id.id',
                    'gallery.directus_files_id.width',
                    'gallery.directus_files_id.height',
                    'gallery.directus_files_id.title',
                    'gallery.directus_files_id.blurhash',
                ],
                filter: { url: { _eq: slug } },
            }
        })
        const [conferences] = await Promise.all([fetchPage])

        return {
            page: conferences ? conferences[0] : null
        }
    }

    const getConferenceRegistration = async (slug: any) => {
        const fetchPage = getItems<any>({
            collection: 'conferences',
            params: {
                fields: [
                    'id',
                    'title',
                    'delegates_fee',
                    'post_conference_event_fee',
                    'participant_attendance_options.id',
                    'participant_attendance_options.label',
                    'participant_attendance_options.apply_fee',
                    'participant_attendance_options.available_to_guests',
                    'accompanying_person_attendance_options.id',
                    'accompanying_person_attendance_options.label',
                    'accompanying_person_attendance_options.apply_fee',
                    'accompanying_person_attendance_options.available_to_guests',
                    'end_registration',

                    'cancellation_policy_title',
                    'cancellation_policy'
                ],
                filter: { url: { _eq: slug } },
            }
        })
        const fetchCountries = getItems<any>({
            collection: 'country',
            params: {
                limit: -1,
                fields: [
                    'id',
                    'nicename',
                ],
                sort: 'nicename'
            }
        })

        const [conferences, countries] = await Promise.all([fetchPage, fetchCountries])
        return {
            page: conferences ? conferences[0] : null,
            countries
        }
    }

    const getConferenceCheckout = async (id: any) => {
        const fetchPage = getItems<any>({
            collection: 'conferences',
            params: {
                fields: [
                    'url',

                    'cover.id',
                    'cover.width',
                    'cover.height',
                    'cover.title',
                    'cover.blurhash',

                    'title',
                    'delegates_fee',
                    'post_conference_event_fee',
                    'participant_attendance_options.id',
                    'participant_attendance_options.label',
                    'participant_attendance_options.apply_fee',
                    'accompanying_person_attendance_options.id',
                    'accompanying_person_attendance_options.label',
                    'accompanying_person_attendance_options.apply_fee'
                ],
                filter: { id: { _eq: id } },
            }
        })
        const [conferences] = await Promise.all([fetchPage])
        return {
            page: conferences ? conferences[0] : null,
        }
    }

    const getConferenceProgramme = async (slug: any) => {
        const fetchPage = getItems<any>({
            collection: 'conferences',
            params: {
                fields: [
                    'title',

                    'programmes.type',
                    'programmes.days.day_number',
                    'programmes.days.day_date',
                    'programmes.days.schedule',
                ],
                filter: { url: { _eq: slug } },
            }
        })

        const [conferences] = await Promise.all([fetchPage])

        return {
            page: conferences ? conferences[0] : null
        }
    }

    const getConferenceWorkshop = async (slug: any) => {
        const fetchPage = getItems<any>({
            collection: 'conferences',
            params: {
                fields: [
                    'title',

                    'workshops.title',
                    'workshops.day_date',
                    'workshops.schedule',
                ],
                filter: { url: { _eq: slug } },
            }
        })

        const [conferences] = await Promise.all([fetchPage])

        return {
            page: conferences ? conferences[0] : null
        }
    }

    const getConferenceSpeakers = async (slug: any) => {
        const fetchPage = getItems<any>({
            collection: 'conferences',
            params: {
                fields: [
                    'title',

                    'speakers.presentation_title',
                    'speakers.avatar.id',
                    'speakers.avatar.width',
                    'speakers.avatar.height',
                    'speakers.avatar.title',
                    'speakers.avatar.blurhash',
                    'speakers.name',
                    'speakers.role',
                    'speakers.biography',
                    'speakers.downloads.directus_files_id.id',
                    'speakers.downloads.directus_files_id.title',
                ],
                filter: { url: { _eq: slug } },
            }
        })

        const [conferences] = await Promise.all([fetchPage])

        return {
            page: conferences ? conferences[0] : null
        }
    }

    const getConferenceAccomodation = async (slug: any) => {
        const fetchPage = getItems<any>({
            collection: 'conferences',
            params: {
                fields: [
                    'title',

                    'accomodation_name',
                    'accomodation_address',
                    'accomodation',
                    'accomodation_nodes.id',
                    'accomodation_nodes.item:articles_nodes_image.image.id',
                    'accomodation_nodes.item:articles_nodes_image.image.width',
                    'accomodation_nodes.item:articles_nodes_image.image.height',
                    'accomodation_nodes.item:articles_nodes_image.image.title',
                    'accomodation_nodes.item:articles_nodes_image.image.description',
                    'accomodation_nodes.item:articles_nodes_image.image.light_caption',
                    'accomodation_nodes.item:articles_nodes_image.image.blurhash',
                    'accomodation_nodes.item:articles_nodes_image.caption',
                    'accomodation_nodes.item:articles_nodes_youtube.youtube_link',
                ],
                filter: { url: { _eq: slug } },
            }
        })

        const [conferences] = await Promise.all([fetchPage])

        if (conferences && conferences[0]) {
            injectDataIntoContent(conferences[0].accomodation_nodes, conferences[0].accomodation)
            delete conferences[0].accomodation_nodes
        }

        return {
            page: conferences ? conferences[0] : null
        }
    }

    const getConferenceLinks = async (slug: any) => {
        const fetchPage = getItems<any>({
            collection: 'conferences',
            params: {
                fields: [
                    'title',
                    'links',
                ],
                filter: { url: { _eq: slug } },
            }
        })

        const [conferences] = await Promise.all([fetchPage])

        return {
            page: conferences ? conferences[0] : null
        }
    }

    return {
        getConferencesPage,

        getConference,
        getConferenceOverview,
        getConferenceGallery,
        getConferenceRegistration,
        getConferenceProgramme,
        getConferenceWorkshop,
        getConferenceSpeakers,
        getConferenceAccomodation,
        getConferenceLinks,

        getConferenceCheckout
    }

}